module.exports = __webpack_public_path__ + "fonts/Bilthers-2.df56868a.ttf";